export const PROFILE_TAB_ITEMS = [
    { value: 'scheduledBroadcast', label: '예정 라이브' },
    { value: 'store', label: '상점' },
    { value: 'lounges', label: '라운지' },
    { value: 'liveSnapshots', label: '힛 갤러리' },
    { value: 'dealerChat', label: '딜러 채팅방' },
];
export const PROFILE_SCREEN_FIELDS = [
    {
        key: 'profile.tabs.order',
        group: '탭',
        label: '탭 순서',
        help: '다른 사용자 프로필 화면 탭의 순서. 그 프로필에 없는 탭(수집가의 예정 라이브·상점·딜러 채팅방, 글이 없는 힛 갤러리)은 건너뛰고, 프로필을 열면 남은 탭 중 맨 앞 탭이 선택된다(알림 등으로 탭을 지정해 열 때는 그 탭)',
        type: 'order',
        defaultValue: PROFILE_TAB_ITEMS.map((item) => item.value),
        items: PROFILE_TAB_ITEMS,
    },
    {
        key: 'profile.stats.postsCountVisible',
        group: '프로필 정보',
        label: '게시물 수 노출',
        help: '끄면 프로필 사진 옆 숫자 줄에서 게시물 수를 빼고 팔로워·팔로잉 수만 보인다',
        type: 'boolean',
        defaultValue: true,
    },
    {
        key: 'profile.scheduledBroadcast.gridColumns',
        group: '예정 라이브 탭',
        label: '예정 라이브 카드 열 수',
        help: '딜러 프로필 예정 라이브 탭에서 한 줄에 놓는 방송 카드 수',
        type: 'integer',
        defaultValue: 2,
        min: 1,
        max: 3,
        unit: '개',
    },
    {
        key: 'profile.store.titleVisible',
        group: '상점 탭',
        label: '상점 탭 제목 노출',
        help: '끄면 딜러 프로필 상점 탭 상품 목록 위의 제목 줄을 그리지 않는다',
        type: 'boolean',
        defaultValue: true,
    },
];
//# sourceMappingURL=profile.js.map